<template>
	<span @click="onClick" class="widget-link">{{ valueText | ftc }}</span>
</template>

<script>
export default {
	name: 'filterBool',
	props: ['name', 'value', 'titleTrue', 'titleFalse'],
	data() {
		return {
			curValue: null
		}
	},
	computed: {
		valueText() {
			return this.curValue ? this.titleTrue : this.titleFalse
		}
	},
	created() {
		this.curValue = this.value
	},
	watch: {
		'value': function(newValue) {
			this.curValue = newValue
		}
	},
	methods: {
		// выбрали значение
		onClick(e) {
			// сообщим родителям что значение поменялось
			this.curValue = !this.curValue
			this.$emit('input', this.curValue)
		}
	}
}
</script>



// WEBPACK FOOTER //
// filterBool.vue?e620a1e6